import { useDataChange } from 'Simple/Data.js'

export function useOnSave(props) {
  let change = useDataChange({
    context: 'letter',
    viewPath: props.viewPath,
  })

  return function save(recipient_id, postal_address_id) {
    change(next => {
      next.recipient_id = recipient_id
      next.postal_address_id = postal_address_id
    })
  }
}
